(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode("@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.animate-fadeIn{-webkit-animation:fadeIn .2s forwards;animation:fadeIn .2s forwards}@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.animate-fadeOut{-webkit-animation:fadeOut .2s forwards;animation:fadeOut .2s forwards}.animate-reveal{-webkit-animation:fadeIn .2s forwards;animation:fadeIn .2s forwards}")),document.head.appendChild(a)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { useRef as N, useState as L, useCallback as C, useEffect as $ } from "react";
const H = {
  RefreshIcon: () => /* @__PURE__ */ l("div", { className: "inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-blue-500 bg-blue-100 rounded-lg dark:text-blue-300 dark:bg-blue-900", children: [
    /* @__PURE__ */ t(
      "svg",
      {
        "aria-hidden": "true",
        className: "w-5 h-5",
        fill: "currentColor",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ t("path", { d: "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" })
      }
    ),
    /* @__PURE__ */ t("span", { className: "sr-only", children: "Refresh icon" })
  ] })
}, S = ({
  title: m,
  body: h,
  show: s = !0,
  icon: f,
  primaryButton: r,
  secondaryButton: a,
  onClose: c,
  hideCloseButton: x,
  autoClose: d,
  maxWidth: b = "max-w-xs",
  padding: v = "p-4",
  buttonDirection: w = "row",
  toastPosition: u = "top",
  toastClassName: k
}) => {
  const e = N(null), [p, g] = L(!s), i = C(() => {
    if (c && c(), !!(e != null && e.current))
      return e.current.classList.remove("animate-reveal"), e.current.classList.add("animate-fadeOut"), window.setTimeout(() => {
        e != null && e.current && g(!0);
      }, 200);
  }, [c]), y = () => {
    g(!1), e != null && e.current && (e.current.classList.remove("animate-fadeOut"), e.current.classList.add("animate-reveal"));
  };
  return $(() => {
    const o = [];
    if (s)
      y(), d && o.push(
        window.setTimeout(() => {
          i();
        }, d)
      );
    else {
      const n = i();
      n && o.push(n);
    }
    return () => o.forEach((n) => clearTimeout(n));
  }, [i, d, s]), p ? null : /* @__PURE__ */ t(
    "div",
    {
      ref: e,
      className: "flex w-full h-full fixed top-0 left-0 bg-black/50 z-[99991]",
      children: /* @__PURE__ */ t(
        "div",
        {
          className: k || `flex w-full fixed justify-center items-center ${u === "top" ? "top-4" : u === "bottom" ? "bottom-4" : "top-1/2 -translate-y-1/2"}`,
          role: "alert",
          children: /* @__PURE__ */ l(
            "div",
            {
              className: `mx-2 flex ${b} ${v} drop-shadow-lg border-slate-600 border animate-reveal text-gray-500 bg-white rounded-lg shadow-xl dark:bg-gray-800 dark:text-gray-400`,
              children: [
                f,
                /* @__PURE__ */ l("div", { className: "ml-3 text-sm font-normal", children: [
                  /* @__PURE__ */ t("span", { className: "mb-1 text-sm font-semibold text-gray-900 dark:text-white", children: m }),
                  /* @__PURE__ */ t("div", { className: "mb-2 text-sm font-normal", children: h }),
                  /* @__PURE__ */ l(
                    "div",
                    {
                      className: (
                        // If there are two buttons, use grid layout
                        r && a ? w === "row" ? "grid grid-cols-2 gap-2" : "grid grid-cols-1 gap-2" : ""
                      ),
                      children: [
                        r && /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
                          "button",
                          {
                            onClick: r.onClick,
                            className: `inline-flex items-center justify-center w-full h-[30px] px-2 py-1.5 ${r.textSize ?? "text-xs"} ${r.fontWeight ?? "font-medium"} text-center text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-500 dark:hover:bg-blue-600 dark:focus:ring-blue-800`,
                            children: r.label
                          }
                        ) }),
                        a && /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
                          "button",
                          {
                            onClick: a.onClick,
                            className: `inline-flex items-center justify-center w-full h-[30px] px-2 py-1.5 ${a.textSize ?? "text-xs"} ${a.fontWeight ?? "font-medium"} text-center text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 dark:text-white dark:border-gray-700 dark:hover:bg-gray-500 dark:focus:ring-gray-600`,
                            children: a.label
                          }
                        ) })
                      ]
                    }
                  )
                ] }),
                !x && /* @__PURE__ */ l(
                  "button",
                  {
                    type: "button",
                    onClick: i,
                    className: "ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700",
                    "data-dismiss-target": "#toast-interactive",
                    "aria-label": "Close",
                    children: [
                      /* @__PURE__ */ t("span", { className: "sr-only", children: "Close" }),
                      /* @__PURE__ */ t(
                        "svg",
                        {
                          "aria-hidden": "true",
                          className: "w-5 h-5",
                          fill: "currentColor",
                          viewBox: "0 0 20 20",
                          xmlns: "http://www.w3.org/2000/svg",
                          children: /* @__PURE__ */ t("path", { d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" })
                        }
                      )
                    ]
                  }
                )
              ]
            }
          )
        }
      )
    }
  );
};
export {
  H as Icons,
  S as InteractiveToast
};
